import React from "react";
import CertificatesInformation from "./certificatesInformation";

function Index() {
  return <CertificatesInformation />;
}

export default Index;
